import { render } from "./ApproveUsers.vue?vue&type=template&id=9520b6ee&scoped=true"
import script from "./ApproveUsers.vue?vue&type=script&lang=js"
export * from "./ApproveUsers.vue?vue&type=script&lang=js"

import "./ApproveUsers.vue?vue&type=style&index=0&id=9520b6ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9520b6ee"]])

export default __exports__